import api from "./api";
import { Auth } from "aws-amplify";

class UsersService {
    getUser() {
        return api.get('/user');
    };

    postUser(user) {
        return api.post('/user/update', user);
    };

    deleteAccount() {
        return api.get('/user/delete-account');
    }
    
    signOut() {
        // Eliminar token de impersonación
        localStorage.removeItem('n30xp5jdk7a');
        
        // Limpiar las cookies relacionadas con Google Auth para evitar problemas con múltiples cuentas
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            
            // Limpiar cookies específicas de Google Auth y OIDC
            if (name.startsWith('AMCV_') || 
                name.startsWith('g_') || 
                name.startsWith('OIDCIdToken') || 
                name.startsWith('CognitoIdentityServiceProvider')) {
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';
            }
        }
        
        // Forzar la redirección completa después del cierre de sesión para asegurar un estado limpio
        const signOutPromise = Auth.signOut({ global: true });
        
        // Limpiar el almacenamiento local de AWS Amplify
        Object.keys(localStorage)
            .filter(key => key.startsWith('app-revopic-') || key.startsWith('CognitoIdentityServiceProvider'))
            .forEach(key => localStorage.removeItem(key));
            
        return signOutPromise;
    };
    
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UsersService();